module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_7.fc1cc5d9.png";